module.exports = __webpack_public_path__ + "img/img_event_pop_01.bb0df53f.png";